define(["require", "exports", "jquery"], function (require, exports) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    $(function () {
        var id = 'vde-baufinanzierung';
        var iframe = document.getElementById(id);
        var scrollOffset = 0;
        var brandingLegalsHeight = 0;
        if (iframe) {
            /* VDE BauFi-Vergleich resize */
            window.addEventListener('message', function (event) {
                if (event.data.type === 'vde-vergleich.iframe.resized' && event.data.data.id === 'vde-baufinanzierung-vergleich') {
                    brandingLegalsHeight = iframe.dataset.brandinglegalsheight ? parseInt(iframe.dataset.brandinglegalsheight) : 0;
                    iframe.style.height = (event.data.data.height + brandingLegalsHeight) + 'px';
                    iframe.style.minHeight = '0';
                }
            }.bind(iframe));
            /* VDE BauFi-Antrag 2020 resize */
            window.addEventListener('message', function (event) {
                if (event.data.type === 'vde-kontaktformular.iframe.resized' && event.data.data.id === 'vde-baufinanzierung-antrag-2020') {
                    brandingLegalsHeight = iframe.dataset.brandinglegalsheight ? parseInt(iframe.dataset.brandinglegalsheight) : 0;
                    iframe.style.height = (event.data.data.height + brandingLegalsHeight) + 'px';
                    iframe.style.minHeight = '0';
                }
            }.bind(iframe));
            /* VDE BauFi-Antrag 2020 scrollTo */
            window.addEventListener('message', function (event) {
                if (event.data.type === 'vde-kontaktformular.iframe.scrolled' && event.data.data.id === 'vde-baufinanzierung-antrag-2020') {
                    scrollOffset = iframe.dataset.scrolloffset ? parseInt(iframe.dataset.scrolloffset) : 0;
                    window.scrollTo({
                        top: (event.data.data.top + scrollOffset),
                        left: 0,
                        behavior: 'smooth'
                    });
                }
            }.bind(iframe));
            /* VDE BauFi-Antrag 2020 leadTracking */
            window.addEventListener('message', function (event) {
                if (event.data.type === 'tracking' && event.data.event_action === 'Vergleich.de Baufilead') {
                    // @ts-ignore
                    var dataLayer = window.dataLayer || [];
                    if (dataLayer) {
                        dataLayer.push({
                            'event': event.data.event,
                            'gaEventCategory': event.data.event_category,
                            'gaEventAction': event.data.event_action,
                            'gaEventLabel': event.data.event,
                            'HitType': 'event'
                        });
                    }
                }
            }.bind(iframe));
        }
    });
});
